import { Component, Input } from '@angular/core';

export interface AuditStamped {
  created?: Date;
  createdBy?: string;
  lastModified?: Date;
  lastModifiedBy?: string;
}

@Component({
  selector: 'app-record-meta',
  templateUrl: './record-meta.component.html',
  styleUrls: ['./record-meta.component.scss']
})
export class RecordMetaComponent {
  @Input() record: AuditStamped | null | undefined = null;
}
